import { StaticMenuItems } from './../models/static-menu-items';
import { RouterData } from './../models/role-permissions';
import { ArcoMenu } from './../models/arco-menu';
import { ArcoResults } from './../models/arco-results';
import { AuthService } from './auth.service';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { ActionPermissions } from '../models/action-permissions';
import { of } from 'rxjs';
import { ActionTypeEnum, MenuRolePermissionEnum, Module, Reflection } from 'itcores-fw';
import { AuthTypeEnum } from '../models/auth-type-enum';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { AppUrls } from '../../core/helpers/app-urls';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  /* #region  Fields */
  @Output() menuPagesRecieved: EventEmitter<ArcoMenu[]> = new EventEmitter();
  private menuItems: ArcoMenu[];
  private modules: Module[];
  private serviceUrl = `${environment.arcoApiUrl}/security`;
  private observable;
  /* #endregion */

  /* #region  Constructor */
  constructor(
    private _http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private msalService: MsalService
  ) { }
  /* #endregion */

  /* #region  Methods */
  getUserMenu() {
    if (
      environment.useFakeAuthServer === true &&
      environment.production === false
    ) {
      return of(StaticMenuItems);
    }
    if (!this.observable) {
      const authType = this.authService.getAuthType();
      let menuUrl = '';
      if (authType === AuthTypeEnum.NotAuthenticated) {
        this.authService.goToLogin();
        // this.router.navigate([AppUrls.notAuthorized]);
      } else if (authType === AuthTypeEnum.Custom) {
        menuUrl = `${this.serviceUrl}/GetMenuByUser?UserName=${this.authService.currentUser.UserName}&ModuleId=Shared`;
      } else if (authType === AuthTypeEnum.OIDC) {
        const account = this.msalService.instance.getActiveAccount();
        if (!account) {
          this.authService.goToLogin();
        }
        menuUrl = `${this.serviceUrl}/GetMenuByEmail?Email=${account.username}&ModuleId=Shared`;
      } else {
        return;
      }
      if (menuUrl) {
        this.observable = this._http.get<ArcoResults<ArcoMenu>>(menuUrl).map(
          (response) => {
            this.observable = null;
            //////////////
            // for (let index = 0; index < response.data.length; index++) {
            //   const element = response.data[index];
            //   element.CanExport = true;
            //   element.RolePermission = 4;
            // }
            //////////////
            this.setMenuItems(response.data);
            if (
              !response ||
              !response.status ||
              !response.data ||
              !response.data.length ||
              response.data.length === 0
            ) {
              this.onAccessDenied();
            }
            return response;
          },
          (error) => {
            this.authService.logout();
          }
        );
      }
    }
    return this.observable;
  }

  setMenuItems(menuItems: ArcoMenu[]) {
    this.menuItems = menuItems || [];
    this.menuItems.sort((a, b) => a.MenuOrder - b.MenuOrder);
    if (this.menuPagesRecieved) {
      this.menuPagesRecieved.emit(this.menuItems);
    }
  }

  canActivatePage(pageRoute: string, routerData: RouterData) {
    if (!this.menuItems || this.menuItems.length === 0) {
      return this.getUserMenu().map((result) => {
        return this.hasAccess(pageRoute, routerData);
      });
    } else {
      return this.hasAccess(pageRoute, routerData);
    }
  }

  getMenuItems() {
    return this.menuItems || [];
  }

  searchMenuItems(title: string) {
    title = title ? title.toLowerCase() : '';
    this.menuItems = this.menuItems.filter(
      (thisItem) =>
        thisItem.title.toLowerCase().includes(title) &&
        (!thisItem.action ||
          this.menuItems.find(
            (menuItem) => menuItem.ParentKey === thisItem.MenuId
          ) != null)
    );

    const menuItems = this.menuItems;
    this.menuItems.forEach((menu) => {
      let prefix = '';
      const parent = menuItems.find(
        (m) => m.MenuId.toString() === menu.ParentKey
      );
      prefix += parent.title;
      const tt = prefix + ' ' + menu.title;
      menu.title = prefix + ' ' + menu.title;
    });

    return this.menuItems;
  }

  searchEntityModul(title: string) {
    title = title ? title.toLowerCase() : '';
    const items = this.menuItems.filter(
      (thisItem) =>
        thisItem.title.toLowerCase().includes(title) &&
        (!thisItem.action ||
          this.menuItems.find(
            (menuItem) => menuItem.ParentKey === thisItem.MenuId
          ) != null)
    );

    const menuItems = Reflection.copy(items);
    const parents = Reflection.copy(this.menuItems);

    menuItems.forEach((menu) => {
      let prefix = '';
      const parent = parents.find(
        (m) => m.MenuId.toString() === menu.ParentKey
      );
      if (parent && parent !== null) {
        prefix = parent.title;
        menu.title = prefix + ' - ' + menu.title;
      }
    });

    return menuItems;
  }

  getAllModules() {
    this.modules = [];
    this.modules = this.searchMenuItems('') as any;

    this.modules.forEach((module) => {
      const parent = this.menuItems.find(
        (m) => m.MenuId.toString() === module.ParentKey
      );
      module.ParentTitleEn =
        parent && parent.title && parent.titleAr ? parent.title : '';
      module.ParentTitleAr =
        parent && parent.title && parent.titleAr ? parent.titleAr : '';
    });

    return this.modules;
  }

  hasAccess(pageRoute, routerData: RouterData) {
    if (
      environment.useFakeAuthServer === true &&
      environment.production === false
    ) {
      return true;
    }
    if (pageRoute && this.menuItems && this.menuItems.length > 0) {
      const menuPage =
        routerData && routerData.parentPage
          ? this.getPageByUrl(routerData.parentPage)
          : this.getPageByUrl(pageRoute);

      let isAllowed = Boolean(menuPage);
      if (!menuPage) {
        isAllowed = false;
      } else if (routerData && routerData.permissions) {
        isAllowed =
          routerData.permissions.indexOf(menuPage.RolePermission) > -1;
      }
      if (!isAllowed) {
        this.onAccessDenied();
      }
      return isAllowed;
    }
    return false;
  }

  private onAccessDenied() {
    this.router.navigate([AppUrls.notAuthorized]);
    // this.alertService.errorMessage('Access Denied');
  }

  getPageByUrl = (pageRoute: string) => {
    return this.menuItems && this.menuItems.length > 0
      ? this.menuItems.find((i) => {
        if (i && i.action && pageRoute) {
          return (
            i.action.trim().toLowerCase() ===
            pageRoute.split('?')[0].trim().toLowerCase()
          );
        } else {
          return false;
        }
      })
      : null;
  };

  checkPageActionPermission = (actionType, pageRoute: string) => {
    if (
      actionType &&
      !Array.isArray(actionType) &&
      typeof actionType === 'object' &&
      pageRoute
    ) {
      if (actionType.permissions && actionType.permissions.length > 0) {
        const page = this.getPageByUrl(pageRoute);
        if (page && page.RolePermission) {
          if (
            actionType.permissions.indexOf(MenuRolePermissionEnum.CanExport) > -1
          ) {
            return page.CanExport;
          } else {
            return actionType.permissions.indexOf(page.RolePermission) > -1;
          }
        }
      }
      return true;
    } else if (actionType && Array.isArray(actionType) && pageRoute) {
      if (actionType.length > 0) {
        const page = this.getPageByUrl(pageRoute);
        if (page && page.RolePermission) {
          if (actionType.indexOf(MenuRolePermissionEnum.CanExport) > -1) {
            return page.CanExport;
          } else {
            return actionType.indexOf(page.RolePermission) > -1;
          }
        }
      }
      return true;
    } else if (
      actionType &&
      typeof actionType === 'string' &&
      ActionPermissions[actionType] &&
      pageRoute
    ) {
      const page = this.getPageByUrl(pageRoute);
      if (page && page.RolePermission) {
        if (actionType === ActionTypeEnum.print) {
          return page.CanExport;
        } else {
          return (
            ActionPermissions[actionType].indexOf(page.RolePermission) > -1
          );
        }
      }
    } else {
      return false;
    }
  };

  /* #endregion */
}